module.exports = __webpack_public_path__ + "img/result_4.2768c01c.png";